import { AmberHoc, AmberHocProps } from '../../../util';
import {
  GrainBinNotificationOptIn,
  UpdateGrainBinNotificationPrefMutationVariables as Variables,
  withUpdateGrainBinNotificationPref as HOC,
} from '../__generated';
import { GraphQLErrors } from './error';

export type withUpdateGrainBinNotificationPrefHocChildProps = {
  updateGrainBinNotificationPref: (
    variables: Variables
  ) => Promise<{ __typename: 'GrainBinNotificationOptIn' } & GrainBinNotificationOptIn>;
};

export const withUpdateGrainBinNotificationPrefHoc: AmberHoc<
  {},
  withUpdateGrainBinNotificationPrefHocChildProps
> = (component) =>
  HOC<
    AmberHocProps<{}, withUpdateGrainBinNotificationPrefHocChildProps, typeof component>,
    withUpdateGrainBinNotificationPrefHocChildProps
  >({
    options: { errorPolicy: 'all' },
    props: (props) => {
      const { mutate } = props;
      return {
        updateGrainBinNotificationPref: async (variables) => {
          if (!mutate) {
            throw new Error('Unexpected UI error');
          }

          const result = await mutate({ variables });

          if (!result) {
            throw new Error('Unexpected server response');
          }

          const { errors, data } = result;
          if (errors) {
            throw new GraphQLErrors(errors);
          }
          if (!data) {
            throw new Error('Unexpected server response');
          }
          return data.updateGrainBinNotificationPref;
        },
      };
    },
  })(component as any);
